export const API_END_POINT = {
    BASE_URL: 'https://api.pvalsry.in/'
}